import { css } from '@emotion/react'

export const styles = css`
  .dark {
    .rc-tree .rc-tree-treenode {
      margin: 0;
      padding: 0;
      line-height: 28px;
      white-space: nowrap;
      list-style: none;
      outline: 0;
      color: #fff;
    }
    .rc-tree .rc-tree-title:hover {
      background: var(--ow-color-darkTheme-800);
      border-radius: 4px;
    }
    .rc-tree .rc-tree-treenode span.rc-tree-switcher.rc-tree-switcher_open {
      background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAUZJREFUWEftlUFKA0EURF8ZUMSFh3AtLkXBhbr2Dp7EJF7FC7gWFEQIiODChQcRXKgkJV9saEImMz1RojC9nZlfVa/oP2LJR0vWpzPQEegI/B8CtsNsr2BvjCW57v2/T8D2iqSJ7W3gFHgFVuYkmwDrwIWkpyA3j0QtgTTA9iZwC+wA44o6QjzMPQKHkl4WNhBJMwp7wA2wBoRYHiD6DvEgdCTpwXZPUpitPLUE0pdpmO0B0J9BIVHpSzpvIh6zSwx8dWl7A7gGdjMTCf3oO/1bHfoUrLGBqSr2p6pI6I8l3TdNX0RgRhVD4Ax4B1aBgaRhiXhbA3kVV0DQuAMi/UdT9K0qyCik3XAAXAInkkal6VsRyO+T7biOW5KeS5MvRCAjkeqYu+1+ZA9UDUlLqu6nU/W86Bq2FflVAoua6gh0BDoCSyfwCVbMnyGwZR2tAAAAAElFTkSuQmCC');
      background-size: cover;
    }

    .rc-tree .rc-tree-treenode span.rc-tree-switcher.rc-tree-switcher_close {
      background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAUZJREFUWEftlUFKA0EURF8ZUMSFh3AtLkXBhbr2Dp7EJF7FC7gWFEQIiODChQcRXKgkJV9saEImMz1RojC9nZlfVa/oP2LJR0vWpzPQEegI/B8CtsNsr2BvjCW57v2/T8D2iqSJ7W3gFHgFVuYkmwDrwIWkpyA3j0QtgTTA9iZwC+wA44o6QjzMPQKHkl4WNhBJMwp7wA2wBoRYHiD6DvEgdCTpwXZPUpitPLUE0pdpmO0B0J9BIVHpSzpvIh6zSwx8dWl7A7gGdjMTCf3oO/1bHfoUrLGBqSr2p6pI6I8l3TdNX0RgRhVD4Ax4B1aBgaRhiXhbA3kVV0DQuAMi/UdT9K0qyCik3XAAXAInkkal6VsRyO+T7biOW5KeS5MvRCAjkeqYu+1+ZA9UDUlLqu6nU/W86Bq2FflVAoua6gh0BDoCSyfwCVbMnyGwZR2tAAAAAElFTkSuQmCC');
      transform: rotate(-90deg);
      background-size: cover;
    }
  }
  .rc-tree {
    margin: 0;
    height: 100%;
    overflow: auto;
  }
  .rc-tree-list-holder {
    overflow-y: hidden !important;
  }
  .rc-tree-focused:not(.rc-tree-active-focused) {
    border-color: cyan;
  }

  .rc-tree .rc-tree-treenode {
    margin: 0;
    padding: 0;
    line-height: 28px;
    white-space: nowrap;
    list-style: none;
    outline: 0;
    color: #191919;
  }

  .rc-tree .rc-tree-treenode .draggable {
    color: #333;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    /* Required to make elements draggable in old WebKit */
  }

  .rc-tree .rc-tree-treenode.dragging {
    background: rgba(100, 100, 255, 0.1);
  }

  .rc-tree .rc-tree-treenode.drop-container > .draggable::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    box-shadow: inset 0 0 0 2px red;
    content: '';
  }

  .rc-tree .rc-tree-treenode.drop-container ~ .rc-tree-treenode {
    border-left: 2px solid chocolate;
  }

  .rc-tree .rc-tree-treenode.drop-target {
    background-color: yellowgreen;
  }

  .rc-tree .rc-tree-treenode.drop-target ~ .rc-tree-treenode {
    border-left: none;
  }

  .rc-tree .rc-tree-treenode.filter-node > .rc-tree-node-content-wrapper {
    color: #a60000 !important;
    font-weight: bold !important;
  }

  .rc-tree .rc-tree-treenode ul {
    margin: 0;
    padding: 0 0 0 18px;
  }

  .rc-tree .rc-tree-treenode .rc-tree-node-content-wrapper {
    position: relative;
    display: inline-block;
    margin: 2px 0;
    height: 28px;
    padding: 0;
    text-decoration: none;
    vertical-align: top;
    cursor: pointer;
  }

  .rc-tree .rc-tree-treenode span.rc-tree-switcher {
    display: inline-block;
    position: relative;
    top: 3px;
    width: 19px;
    height: 19px;
    line-height: 16px;
  }
  .rc-tree .rc-tree-title:hover {
    background: #e7e7e7;
    border-radius: 4px;
  }

  .rc-tree .rc-tree-node-selected .rc-tree-title:hover {
    background: var(--ow-color-primary-100);
    border-radius: 4px;
  }

  .rc-tree .rc-tree-treenode span.rc-tree-checkbox {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 2px;
    line-height: 16px;
    vertical-align: -0.125em;
    background-color: transparent;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUAAAABgCAYAAABsS6soAAAACXBIWXMAAAsTAAALEwEAmpwYAAAHtGlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDIgNzkuMTYwOTI0LCAyMDE3LzA3LzEzLTAxOjA2OjM5ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtbG5zOnN0RXZ0PSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VFdmVudCMiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIiB4bWxuczpwaG90b3Nob3A9Imh0dHA6Ly9ucy5hZG9iZS5jb20vcGhvdG9zaG9wLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpiYjc2NGQ1ZC0yNzAyLTI1NDUtOTUzZi0zZGQ1OTk3MjRlYjAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QjY4MjhENEM0QTEzMTFFQkFBNUFBQTU3RjQxMjk5NjciIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OTM3OWJkNTctMDRiOC02NTRiLWFiMGEtYWViMmRlOWVkZmIzIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE4IChXaW5kb3dzKSIgeG1wOkNyZWF0ZURhdGU9IjIwMjAtMTItMzBUMDI6Mzc6MjYrMDY6MDAiIHhtcDpNb2RpZnlEYXRlPSIyMDIxLTAxLTEzVDAzOjM2OjE0KzA2OjAwIiB4bXA6TWV0YWRhdGFEYXRlPSIyMDIxLTAxLTEzVDAzOjM2OjE0KzA2OjAwIiBkYzpmb3JtYXQ9ImltYWdlL3BuZyIgcGhvdG9zaG9wOkNvbG9yTW9kZT0iMyIgcGhvdG9zaG9wOklDQ1Byb2ZpbGU9InNSR0IgSUVDNjE5NjYtMi4xIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OTA3MGRiZGEtNDkyMi01YjQwLTk5NmEtN2M0MzQ3YWQxMzhmIiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6ODYwMzkyYjYtNTNiZC1hMjRjLTlkODAtNzU1MTMwNjBiMmM3Ii8+IDx4bXBNTTpIaXN0b3J5PiA8cmRmOlNlcT4gPHJkZjpsaSBzdEV2dDphY3Rpb249InNhdmVkIiBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOjI2MTgzZjJmLWE0YzUtOTg0OC04NjYxLWRlZmVhYTA0NjU1YSIgc3RFdnQ6d2hlbj0iMjAyMS0wMS0xM1QwMzozNDoxNiswNjowMCIgc3RFdnQ6c29mdHdhcmVBZ2VudD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpIiBzdEV2dDpjaGFuZ2VkPSIvIi8+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJzYXZlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDo5Mzc5YmQ1Ny0wNGI4LTY1NGItYWIwYS1hZWIyZGU5ZWRmYjMiIHN0RXZ0OndoZW49IjIwMjEtMDEtMTNUMDM6MzY6MTQrMDY6MDAiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE4IChXaW5kb3dzKSIgc3RFdnQ6Y2hhbmdlZD0iLyIvPiA8L3JkZjpTZXE+IDwveG1wTU06SGlzdG9yeT4gPHBob3Rvc2hvcDpEb2N1bWVudEFuY2VzdG9ycz4gPHJkZjpCYWc+IDxyZGY6bGk+YWRvYmU6ZG9jaWQ6cGhvdG9zaG9wOjg2MDM5MmI2LTUzYmQtYTI0Yy05ZDgwLTc1NTEzMDYwYjJjNzwvcmRmOmxpPiA8cmRmOmxpPnhtcC5kaWQ6YmI3NjRkNWQtMjcwMi0yNTQ1LTk1M2YtM2RkNTk5NzI0ZWIwPC9yZGY6bGk+IDwvcmRmOkJhZz4gPC9waG90b3Nob3A6RG9jdW1lbnRBbmNlc3RvcnM+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+kTYvIAAAEHxJREFUeJzt3X9wFGWex/H303ElIUACHBJ+CSHqwhol4A80bjQn6srK4ar4Gw6sBIVCEWtB2HNd9U7vQKxa70pP7zQnt5xXd6db51pEvZNQWcGsgEBEOJBDISWSgLcIJGHAmXme+2NmwiSZwPSke3qS/r6qUpnpyfT36Z7MZ56nu6dbGWMQ9vzhs69iNw2gujOvqyeM7Xb9VObRHV7XF/4W//939YSx3Xr/Wd1vjhBC9EwSgEII35IAFEL4lgSgEMK3JACFEL4lASiE8K1zvG6AEF2Zt3TlucBKYCYwyObTvwNWA0teXbHke6kvEpEAFJns+et/fNnCW6aUkts329YTTwRODlyztm7hug1bAsAyqS8SkSFwz9atg0B7QP1Zqbz5AfrmZHPLlFKAuVI/dc0fWfnN63+wqHlDdm3zhtza5o8H1DbX5dc21w2a0535Zoqke4BPrHhtKlAFDEvizxuBiueWzn0/1YZlWn0vnW3Z13xQE3837evexfqDUnnzx0Sfa3foKPXjGGMWQegphYl83BkDZAGmpLluUG3/0iP7uzN/r9kZAlfdMqV0WPG4QrIsK/Fnv4Gw1uzYvW9YdU1dFTDcoXZmQn0veb3sXtfPCF82NLJm3WZaA6ewlEIphVIWyor8zu2bzc3XllA48jyvm+ocQ3nkVxhlDKhoZCiTh2FVc93AWrBQKguwQClAHUVZq/pNPnDUo1YnzU4ADiseV0j/3ByU6nrkY4yheFwh1TV1yfTU7PC6vpe8Xnav62eEdz/8hNbASZSy0JYV3X6kQVtgaVpaA3zwUT3z77vJk/bVbdxK3eZ6FlTcR05O6j3HduJOFWCURpkgoIlEh7kOsq5DGYwBpQwYC5QFRj/dsnHkmEwPQVvbALMsq9MbYEbFknb3lVKRXoILEtXvyM36XpJ1773jLa0YbTBGY7RGG4MxsfsGMLS0BjxpW93GrSx97mV+998f88fvjjo3Y9P+xxgDJgwmCISjt8NAGGPCGMJgNGDyMOGfOdcQd9jbC5zg///Qt0eS+jtHJDtfr3cNuMHmuo87Y8YZJX0mF5vr3vH6GcBojbZAaYVlEen8KYXVdsdCeZD/sfADmDfrZ4wcXuDYvI3p/NIbDBCOTo9tE4zdBqOIDJexxjjWEJf03o9rIRymtUZrjTEmejscd1tjTOS3Ww4cbCIQONlp2vMv/waAmbffxP13/pmzRU10v4chMvJt1xsMgwlFe4EhIj3CyH0T7RVmupSOA5xRsaRd76NsegUAQ4cM4u2qlc60zEb9mHTV76A7J1S03Ve1ue7P1rZu149JV30vGWNAazSR4b5lWWgdxrIiPSCtNcqlLuCBg03cO+8JLr/kIv76l4+Sk5PNgYNNPLxsOX882sz1pRN5aM7dzhc2cb8UKNPxYY0iSMdeYGy7YKZLKQDj/9HLplew/t0qxxpkt77H0v4GtrnuHW+fzXXfowLubIzRgIr0hCwLrXVbCCplnR4Ku2DwwHwG5/fn08/38BfP/i1PLn6oLfwuv+Qilj1a6Urdjh9hnc4ArKIfDISIHCpzzulDZXrAqy/fBElBT9hu5XUbva7vhlgPz7I0aANWVnRaZJug1px1R1GqcnKyeWn5Mh5etpxPP9/DrbN/DtCuR+gK0+G26hCCcXc6HSrTrcFRetjrrydYnqFDEhxn6dZyJzvfzF/v9sm691z/fn2j2/mie391GBO3TdBoTW5OH9fqjxxewEvLT3+rbXB+f36+YLZ74UekM9e2DRDitv/FTY/fLoiObgcMRvcOZzZbARiOvtjxOg6JjDGEXdoQnKh+R27W95Kse+/dPrWM/rkdQjB6SIzRmtzcbKZNudLVNowcXsCKJxZwfelEXlq+zNE9vgnFBV7HsIsEXoJpRsftGMlsdobAjTt270v22wAATc40MWPqe8nrZfe6fkb4YdH5/OKR+71uBqWTJ1E6eVK6yu3HcB1ED4npfExM5LCX+Gmntwu+k6Y2psxOAFZW19RVVdfUJfOR8w3wYIptytT6XvJ62b2qf6T1xMmUvw/beuIkQIKDJaW+DU8DYJgdCbYuP/8i0yM3GlCsGnCdqe9mbdclHYDPLZ37HsmdiMAVXtf3ktfL7mH91dU1dY9Ou6GUvja3c50InKS6pg7gdamfuvypZj8wJ/rT68heYJHJHl+3YYtat2HLLGCgzefGTgj6pNQXXVFyYXQhRE8iF0YXQggHSAAKIXxLAlAI4VsSgEII3/L9XuBkz1t3Nun+7mvHdvutvhBOkB6gEMK3JAC7z+vjiPxeX4iUSQAKIXxLAlAI4VsSgEII35IAFEL4lgSgEMK3JACFEL7l+wOhReaat3TlucBKYCaQ4AIoZxQ7HdSSV1cs+V7qi0QkAEUme/7KicULyyZPIifb3sWGTp46NfCjT7Yu3LRtRwBYdtYnSH1fkgDs+by++qqb9Wel8uYHyO7Th7LJk9i0bcdcUg8Av9dvp6tLfi5+/Alz+cRL2f2/+9nb0MgFoyMnD9+5cztv/fubGX3O0aQD8IkVr00Fqkju1OiNQMVzS+e+n2rDMq2+1862/Gs+qIm/m/b171L9Qam8+WOiz7U7dJT6Nl1QNIo1a//ABaOHsXRRJX/57N8A0KffELdLd5udHmDVLVNKk70y2LDqmroqYLhD7cyE+l7zevm9ru+5/QcaqdmwmROBUyjLQikV92ORm5NN+VUljBp+ntdNdcXMikUJu3I169ZHb53+bIyFX/Q5Xo9SumQnAIcVjyukf25Ol11hiFwOr3hcIdU1dU5fRMfr+l7zevm9ru+5Dz/ayInASZSyQGuw4g+i0LSeCFD7ST2zbr/Jk/Ztqf+cbdt3MvOu28juRs/xTFa//utO08KhEEePHeelv3+dvXvz2v7urntmZnwv0NZhMFnRT714MyqWtLuvlIr0EFyQqH5Hbtb3mqx/bzW3tJ6+GHrsgujGnP7B0Hoi4EnbttR/zguvrKLm480cPXbM1VpZk3/X7ufca6oZPNj1kbYr7O0ESfC/f+jbBJcddavDm+x8M7bD3U2y/j1ljEFrjVIKy7IADZr2PUEPlj0WfgD33PoTCob2ziG4G2QvsIecOhlrT63f0xitQSmwrGgQWlhWNASj0908OVjTocPk5+W1G942HTrM62++DcD0G6/l1p96M/zuqVIKwBkVS9r1PMqmVwAwdMgg3q5a6UzLbNSP6UZ9r/fTn61+u36FC+u/W/Vj0vX6e6XtcI62IAStoyGIdXq6C5oOHeaxX63g4osKWbxgLtnZfWg6dJhnXniZo8dbmDzxYu6dcasrtXuzlAIw/p+8bHoF69+tcqxBdus7xOtBm636Lqz/lOv7iTEag8KKbTrXui0EldLRYbE78vPyyB/Qj5179vHCy6/xcOWft4XfxRcVMm/O/a7V7s18PwT28loWdmp3OM6uV9TvaWLDXm1pVCwItY58fLQNi935LM3O7sNTixfwzAsvs3PPPuY//gxAux5huoQ3Ju5ptrQcT1sbnGIvABMMlIYOSbD3x60BZbLz9XpA6xZZ/57ql9uXltYToK1Iz49YEBLdGaLom9PXtfoFQ8/jqcULeOxXKwDIH9CPypl3pS38/qXqRcUZXt2CwbkAfLZtM7MqH6NPvyFt0zKVrQAMR3f7x3/KdRwOGWMIa+1M65Ko35Gb9b0m699bU6//Me/VrI8c6hINQYgFIQzI6ccNZVe42oaCoeexeP4c1n+ymXtum5b2Pb5/9ctFnaY9+eyLFAzO5Zqr5wFw771/x//sXs2U68uYccedaW2fXXYCsHHH7n3JfhMAoMmZJmZMfa95vfxe1/dc0ZhRPFJxn9fN4LKSS7is5BJPahcWjun0yt959/0md+TN1NfvpDWwntycMn40bhY161aTP2Agd99zlxdNTYqdAKysrqmrqq6pK0jib78BHkyxTZla32teL78X9Y8ETp5K+fuwgZOnABIcKCn1nTTzkXt5640P2u4XDF5PQ8N++vQbwtHj37ldvluSDsDnls59j+ROROAKr+t7zevl96j+6vUbtz567VWTyO5j+3RQrN+4FeB1qe+MM5zVRU2/5hanyqSV7/cCi4z2+KZtO9SmbTtmAQNtPjd2QtAnpb7oSkafq0sIITqK+waTuXrC2G4dd9Q7v7UuhBBJkAAUQviWBKAQwrckAIUQviUBKITwLQlAIYRvSQAKIXxLAlAI4VsSgEII35IAFEL4lgSgEMK3JACFEL4lASiE8C0JQCGEb8n5AHugNbXbBwKXJXhoy7TySzP7FLxCZBBXAnB0w2/HAPkNo++od2P+framdvuDwD908fCWNbXbb5QQFCI5jp8QdVTD2yUWqhbIAx5rGH3Hi44W8Lk1tdu/nPSj878ffl7+uI6Pbdq+j8NHmrcAEoKi18rYE6IO2/9WiYZajcmLTip3cv6NU65sbLzxqm2JHjt0x09GH5pxc+OhGTc7dg2EMxgLLAUGpKFWp9qJwu9A0xEuLx4TGJTX90Lgw+gwWQhxBo4F4KB9/1YSxtRqY/LCxqAxx4CnnZo/gAkF8wiHSxpvnLw3fnrTrVNGo8O7MKYAY751smYCY483t3y5eduO5cByvAnBTg4ePsbxlsCbV5cUISEoRHIcCcDcr/61JISpDRmdF0KjMcfCxpQ7vg0wGBpvQsGACYWLYiHY9NOy0YTDu0xY56DDVUN/+1+/cLRmZzc0fH2Q99d+zOZtO+aTQSG4Yeveym8OfTeg+MIRA4jsJOltlwYVwlFJ7wRRX7y6CqVmg/WAuWjuqrbpX/4m/xysVT9A5aEsMBxDUd405q56pxs7vO7zhm9Ki8crY3YZY4oab5i8F8sarrJMDmRVDX13XaXTNc/k/bUfA8y/YmIxwDLgeDrrx7vy0kKvSgvRYyXfAzR6NsYA+g2157U5AGrvP+VjdG0IPSFoDCGjj4Uw5d+OubvenebCiLodDSYUGk8oFDChYBHhcI4JhaoK1vw+reEXE9cTnO9FfSFE6mwcBqP/GcNsUABvqD2v5aOsOSg9AQMhxTFjVPmJsffXu9TW04JBjDEoYyK/s84pd72mEKLXSboHaMY9PCcSggbQYPSvMXoCRhP9mRMqmlXvWkujDhSPGm1CoV0EgzkmFHyHYKQnePBPL9979mc7b+oN13DFxOJXgFe8qC+ESJ29nSBGLwL9GUYTDUGitx8wF8x5x4X2tfP1hUOi4fd9jgmFqkZs3HWbCQXHm1AoQChYdLD8srSGYFz4ebr9TwiRGlsBaMYvPIrR5Zh2IfiAubBylTvN61A/GNpFKJhjQqGqkZ/tqwQYsWl3A8FYCIaKDpZP+k+Xm7F29KjhEn5C9AK2D4Mx4xceBVOO0Q9g9ETzw3mrnG9WF8KhL0woXDXqi6Z2OzxGbP4iGoLBJoKh37vciq8G9O9XdMXE4mVI+AnRo6X0XeBICLLK0ZYk4fyvmyd29diIT/c0AMPS1JSvgBVpqtWp9r4D/6cLR/7JBV39QdO3x94HpgLydTghzkDOBtPzPLRz78H/2Ln34Jn+Zirw1rTyS/8xTW0SokeSAOxhppVfuhYY5HU7hOgN5ISoQgjfkgAUQviWBKAQwrckAIUQviUBKITwLQlAIYRvSQAKIXxLAlAI4Vv/D/MHdtnhxYsYAAAAAElFTkSuQmCC');
    background-repeat: no-repeat;
    background-attachment: scroll;
    border: 0 none;
    outline: none;
    cursor: pointer;
  }

  .rc-tree .rc-tree-treenode span.rc-tree-switcher.rc-tree-icon__customize,
  .rc-tree .rc-tree-treenode span.rc-tree-checkbox.rc-tree-icon__customize,
  .rc-tree .rc-tree-treenode span.rc-tree-iconEle.rc-tree-icon__customize {
    background-image: none;
  }

  .rc-tree .rc-tree-treenode span.rc-tree-icon_loading {
    margin-right: 2px;
    vertical-align: top;
    background: url('data:image/gif;base64,R0lGODlhEAAQAKIGAMLY8YSx5HOm4Mjc88/g9Ofw+v///wAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFCgAGACwAAAAAEAAQAAADMGi6RbUwGjKIXCAA016PgRBElAVlG/RdLOO0X9nK61W39qvqiwz5Ls/rRqrggsdkAgAh+QQFCgAGACwCAAAABwAFAAADD2hqELAmiFBIYY4MAutdCQAh+QQFCgAGACwGAAAABwAFAAADD1hU1kaDOKMYCGAGEeYFCQAh+QQFCgAGACwKAAIABQAHAAADEFhUZjSkKdZqBQG0IELDQAIAIfkEBQoABgAsCgAGAAUABwAAAxBoVlRKgyjmlAIBqCDCzUoCACH5BAUKAAYALAYACgAHAAUAAAMPaGpFtYYMAgJgLogA610JACH5BAUKAAYALAIACgAHAAUAAAMPCAHWFiI4o1ghZZJB5i0JACH5BAUKAAYALAAABgAFAAcAAAMQCAFmIaEp1motpDQySMNFAgA7')
      no-repeat scroll 0 0 transparent;
  }

  .rc-tree .rc-tree-treenode span.rc-tree-switcher.rc-tree-switcher-noop {
    cursor: auto;
  }

  .rc-tree .rc-tree-treenode span.rc-tree-switcher.rc-tree-switcher_open {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAATZJREFUWEft0z1KxUAUxfHfEz/R2sZOBa0t3YOV7kKwUHANgpauQux0D7bWgmijKxAUv7mQgRDe82XyAkHIwBRh7txzzv9OBjpeg4719QZ6Aj2Bf0UgzOYY/kHsP1dOw3G9Gp3XMRA1kWQF23gfQyJqZ3CDp6J2JIkcAws4xgbeMDUk8jfmcYeToq6VESQKqzjCNEKsHCBShqkPnOGx+I66kasOgXQ5mkezHezitUIhzhZxges64tE4x0CiMItDbJZMlNGf4rPui8wxkAwH6rXCRDy2EA86IRriD3XT5xIYNoo9vGAJl7jKEW9qII1iDgfYwm3x8L7qok91uSMo34tRrGMf57jPTd+UQDlk/I7LeM5NPimBKok0lmwfTUdQFmos3sYIshNXL7RBYCITvYGeQE+gcwK/+Hk4IYK4lU4AAAAASUVORK5CYII=');
    background-size: cover;
  }

  .rc-tree .rc-tree-treenode span.rc-tree-switcher.rc-tree-switcher_close {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAATZJREFUWEft0z1KxUAUxfHfEz/R2sZOBa0t3YOV7kKwUHANgpauQux0D7bWgmijKxAUv7mQgRDe82XyAkHIwBRh7txzzv9OBjpeg4719QZ6Aj2Bf0UgzOYY/kHsP1dOw3G9Gp3XMRA1kWQF23gfQyJqZ3CDp6J2JIkcAws4xgbeMDUk8jfmcYeToq6VESQKqzjCNEKsHCBShqkPnOGx+I66kasOgXQ5mkezHezitUIhzhZxges64tE4x0CiMItDbJZMlNGf4rPui8wxkAwH6rXCRDy2EA86IRriD3XT5xIYNoo9vGAJl7jKEW9qII1iDgfYwm3x8L7qok91uSMo34tRrGMf57jPTd+UQDlk/I7LeM5NPimBKok0lmwfTUdQFmos3sYIshNXL7RBYCITvYGeQE+gcwK/+Hk4IYK4lU4AAAAASUVORK5CYII=');
    transform: rotate(-90deg);
    background-size: cover;
  }

  .rc-tree .rc-tree-treenode span.rc-tree-checkbox {
    width: 22px;
    height: 24px;
    margin: 0 3px;
    background-position: -165px -2px;
  }

  .rc-tree .rc-tree-treenode span.rc-tree-checkbox-checked {
    background-position: -229px -2px;
  }

  .rc-tree .rc-tree-treenode span.rc-tree-checkbox-indeterminate {
    background-position: -230px -2px;
  }

  .rc-tree .rc-tree-treenode span.rc-tree-checkbox-disabled {
    background-position: -230px -2px;
  }

  .rc-tree
    .rc-tree-treenode
    span.rc-tree-checkbox.rc-tree-checkbox-checked.rc-tree-checkbox-disabled {
    background-position: -14px -56px;
  }

  .rc-tree
    .rc-tree-treenode
    span.rc-tree-checkbox.rc-tree-checkbox-indeterminate.rc-tree-checkbox-disabled {
    position: relative;
    background: #ccc;
    border-radius: 3px;
  }

  .rc-tree
    .rc-tree-treenode
    span.rc-tree-checkbox.rc-tree-checkbox-indeterminate.rc-tree-checkbox-disabled::after {
    position: absolute;
    top: 5px;
    left: 3px;
    width: 5px;
    height: 0;
    border: 2px solid #fff;
    border-top: 0;
    border-left: 0;
    -webkit-transform: scale(1);
    transform: scale(1);
    content: ' ';
  }

  .rc-tree:not(.rc-tree-show-line) .rc-tree-treenode .rc-tree-switcher-noop {
    background: none;
  }

  .rc-tree.rc-tree-show-line .rc-tree-treenode:not(:last-child) > ul {
    background: url('data:image/gif;base64,R0lGODlhCQACAIAAAMzMzP///yH5BAEAAAEALAAAAAAJAAIAAAIEjI9pUAA7')
      0 0 repeat-y;
  }

  .rc-tree.rc-tree-show-line
    .rc-tree-treenode:not(:last-child)
    > .rc-tree-switcher-noop {
    background-position: -56px -18px;
  }

  .rc-tree.rc-tree-show-line
    .rc-tree-treenode:last-child
    > .rc-tree-switcher-noop {
    background-position: -56px -32px;
  }

  .rc-tree-child-tree {
    display: none;
  }

  .rc-tree-child-tree-open {
    display: block;
  }

  .rc-tree-treenode-disabled > span:not(.rc-tree-switcher),
  .rc-tree-treenode-disabled > a,
  .rc-tree-treenode-disabled > a span {
    color: #767676;
    cursor: not-allowed;
  }

  .rc-tree-treenode-active {
    background: rgba(0, 0, 0, 0.1);
  }

  &-treenode-active {
    background: #e7e7e7;
  }

  .rc-tree-node-selected {
    font-weight: 600;
    color: var(--ow-color-primary-700);
    background: var(--ow-color-primary-100);
    border-radius: 4px;
    margin-left: 20px;
  }

  .rc-tree-icon__open {
    margin-right: 2px;
    vertical-align: top;
    background-position: -110px -16px;
  }

  .rc-tree .rc-tree-icon__close {
    margin-right: 2px;
    vertical-align: top;
    background-position: -110px 0;
  }

  .rc-tree-icon__docu {
    margin-right: 2px;
    vertical-align: top;
    background-position: -110px -32px;
  }

  .rc-tree-icon__customize {
    margin-right: 2px;
    vertical-align: top;
  }

  .rc-tree-title {
    display: inline-block;
    font-size: 14px;
    padding: 0 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .rc-tree-indent {
    display: inline-block;
    height: 0;
    vertical-align: bottom;
  }

  .rc-tree-indent-unit {
    display: inline-block;
    width: 16px;
  }

  .rc-tree-draggable-icon {
    display: inline-flex;
    justify-content: center;
    width: 16px;
  }
`
